import React, { useState } from 'react';
import InputField from './InputField';
import { Button, Spin } from 'antd';
import { create_category_action, fetch_categories_action } from '../_redux/action';
import { useDispatch } from 'react-redux';

const CreateCategory = ({ onCategoryChange }) => {
  const [categoryForm, setCategoryForm] = useState();
  const [categoryLoading, setCategoryLoading] = useState(false);

  const dispatch = useDispatch();

  const handleCategoryFormChange = (e) => {
    const { name, value } = e.target;
    setCategoryForm({
      ...categoryForm,
      [name]: value,
    });
  };

  async function onCategorySaveClick() {
    setCategoryLoading(true);
    const categoryData = await dispatch(create_category_action(categoryForm));

    if (categoryData?.data) {
      onCategoryChange(categoryData?.data);
      await dispatch(fetch_categories_action());
    }
    setCategoryLoading(false);
  }

  return (
    <div>
      {categoryLoading ? (
        <div className="centered spinner-box">
          <Spin size="large" />
        </div>
      ) : (
        <div>
          <InputField
            id="title"
            name="title"
            placeholder="Enter category title"
            value={categoryForm?.title || ''}
            onChange={handleCategoryFormChange}
            required
            containerClassName="flex flex-col"
            inputClassName="p-2 border rounded bg-transparent"
            errorClassName="text-xs"
          />

          <Button className="mt-2" onClick={() => onCategorySaveClick()}>
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

export default CreateCategory;
